import { Pages2Icon as Pages } from '@/components/icons/Pages2Icon';
import { useCopyCode } from '@/hooks/useCopyCode.hook';
import { cn } from '@/utils/cn';

export function CopyCode({
  code,
  className,
}: {
  code: string;
  className?: string;
}) {
  const { copyCode } = useCopyCode(code);

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-lg bg-dark-gray',
        className
      )}
    >
      <button
        className="flex cursor-pointer flex-col gap-1 text-left"
        onClick={copyCode}
        type="button"
      >
        <div className="-ml-1">
          <Pages desc="Copy code icon" title="Copy Code" />
        </div>
        <div className="text-gray text-xs leading-5">
          Click to copy and
          <span className="block font-semibold text-light-blue">
            collect bonus
          </span>
        </div>
      </button>
    </div>
  );
}
